function UsersIcon() {
  return (
    <svg
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.50008 7.45768C4.55008 7.45768 0.666748 8.43268 0.666748 10.3744V11.8327H12.3334V10.3744C12.3334 8.43268 8.45008 7.45768 6.50008 7.45768ZM2.61675 10.166C3.31675 9.68268 5.00841 9.12435 6.50008 9.12435C7.99175 9.12435 9.68342 9.68268 10.3834 10.166H2.61675ZM6.50008 5.99935C8.10842 5.99935 9.41675 4.69102 9.41675 3.08268C9.41675 1.47435 8.10842 0.166016 6.50008 0.166016C4.89175 0.166016 3.58341 1.47435 3.58341 3.08268C3.58341 4.69102 4.89175 5.99935 6.50008 5.99935ZM6.50008 1.83268C7.19175 1.83268 7.75008 2.39102 7.75008 3.08268C7.75008 3.77435 7.19175 4.33268 6.50008 4.33268C5.80841 4.33268 5.25008 3.77435 5.25008 3.08268C5.25008 2.39102 5.80841 1.83268 6.50008 1.83268ZM12.3667 7.50768C13.3334 8.20768 14.0001 9.14102 14.0001 10.3744V11.8327H17.3334V10.3744C17.3334 8.69102 14.4167 7.73268 12.3667 7.50768ZM11.5001 5.99935C13.1084 5.99935 14.4167 4.69102 14.4167 3.08268C14.4167 1.47435 13.1084 0.166016 11.5001 0.166016C11.0501 0.166016 10.6334 0.274349 10.2501 0.457682C10.7751 1.19935 11.0834 2.10768 11.0834 3.08268C11.0834 4.05768 10.7751 4.96602 10.2501 5.70768C10.6334 5.89102 11.0501 5.99935 11.5001 5.99935Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default UsersIcon;
